module.exports = __webpack_public_path__ + "img/the-netherlands-transport-accidents-male.6c3075d2.png";